// BS3 $.fn.button compatibility.
//
// Bootstrap 5 removed BS3's stateful buttons (`.button('loading'|'reset')` with
// data-loading-text) and radio/checkbox button groups (data-toggle="buttons").
// This ports the behavior from bootstrap-sass 3.4.1 button.js, including the
// data-disabled-states extension the app added on top (the former
// app/assets/javascripts/custom-bootstrap.js).

export function installButtonCompat($) {
  function setState($el, state) {
    const d = 'disabled';
    const val = $el.is('input') ? 'val' : 'html';
    const data = $el.data();
    let shouldDisable = state === 'loading';

    if (data.disabledStates) {
      if (data.disabledStates.split(',').indexOf(state) !== -1) {shouldDisable = true;}
    }

    state += 'Text';

    if (data.resetText == null) {$el.data('resetText', $el[val]());}

    // push to event loop to allow forms to submit
    setTimeout(() => {
      const fallback = state === 'loadingText' ? 'loading...' : $el.data('resetText');

      $el[val](data[state] == null ? fallback : data[state]);

      if (shouldDisable) {
        $el.data('bs3IsLoading', true).addClass(d).attr(d, d).prop(d, true);
      } else if ($el.data('bs3IsLoading')) {
        $el.data('bs3IsLoading', false).removeClass(d).removeAttr(d).prop(d, false);
      }
    }, 0);
  }

  function toggle($btn) {
    let changed = true;
    const $parent = $btn.closest('[data-toggle="buttons"]');

    if ($parent.length) {
      const $input = $btn.find('input');

      if ($input.prop('type') === 'radio') {
        if ($input.prop('checked')) {changed = false;}
        $parent.find('.active').removeClass('active');
        $btn.addClass('active');
      } else if ($input.prop('type') === 'checkbox') {
        if ($input.prop('checked') !== $btn.hasClass('active')) {changed = false;}
        $btn.toggleClass('active');
      }

      $input.prop('checked', $btn.hasClass('active'));
      if (changed) {$input.trigger('change');}
    } else {
      $btn.attr('aria-pressed', !$btn.hasClass('active'));
      $btn.toggleClass('active');
    }
  }

  const plugin = function (option) {
    return this.each(function () {
      const $el = $(this);

      if (option === 'toggle') {
        toggle($el);
      } else if (option) {
        setState($el, option === 'reset' ? 'reset' : option);
      }
    });
  };

  function register() {
    $.fn.button = plugin;
    $.fn.button.Constructor = plugin;
  }

  register();
  // Bootstrap 5's Button re-registers its own $.fn.button on DOMContentLoaded
  // when it detects jQuery; re-assert the BS3-compatible one afterwards.
  document.addEventListener('DOMContentLoaded', register);

  $(document)
    .on('click.bs3compat.button.data-api', '[data-toggle^="button"]', function (event) {
      const $btn = $(event.target).closest('.btn');

      toggle($btn);

      if (!$(event.target).is('input[type="radio"], input[type="checkbox"]')) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        event.preventDefault();
        // The target component still receive the focus
        if ($btn.is('input,button')) {$btn.trigger('focus');}
        else {$btn.find('input:visible,button:visible').first().trigger('focus');}
      }
    })
    .on('focus.bs3compat.button.data-api blur.bs3compat.button.data-api', '[data-toggle^="button"]', function (event) {
      $(event.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(event.type));
    });
}
